import {FC, useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
//components

//constants
import {toAbsoluteUrl, timeZone} from '../../../helpers'
import {reset, resetRedux} from '../../../../app/Redux/store'
import {
  UpdateLoggedUserInfo,
  getUserData,
} from '../../../../app/modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {getAllUserDetails} from '../../../../app/pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {GeneralDataOFLoginUser} from '../../../../app/Utils/Auth'
import {useSocket} from '../../../../app/Utils/SocketProvider'
import {adminLoginBackToAdmin} from '../../../../app/Redux/AdminPanel/AdminAuthSlice'
import {createFirstLetter} from '../../../../app/Utils/_helpers'
import {startLoadding, stopLoading} from '../../../../app/Redux/FrontEnd/Loading/LoadingSlice'
import {
  useLazyLoginBackToSubClientQuery,
  useLoginAsAffiliateUserMutation,
  useLoginAsParentAffiliateUserMutation,
} from '../../../../services/cellcast.v2'
import {toast} from 'react-toastify'
import {AuthenticateUser} from '../../../../app/Utils/_helpers/RoleAndPermission'
import { MenuComponent } from '../../../assets/ts/components'
import { useTimezone } from '../../../../app/hooks/useTimezone'

const HeaderUserMenu = () => {
  const socketID: any = useSocket()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const isAdmin = localStorage.getItem('isAdmin')
  const isAdminAsUser = localStorage.getItem('isAdminAsUser') ?? 'false'
  const isAdminAsStaff = localStorage.getItem('isAdminAsStaff') ?? 'false'
  const isSubAccount = localStorage.getItem('isSubAccount') ?? 'false'

  const isAffiliateParent = localStorage.getItem('isAffiliateParent') ?? 'false'
  const user = useSelector(getUserData)
  const Admin = GeneralDataOFLoginUser()
  const timeZone2 = useSelector(
    (state: any) => state?.userDetails?.userDetails?.data?.user?.timeZone
  )
  const data = useSelector(getAllUserDetails)

  const [isShowCredit, setIsShowCredit] = useState(true)

  const {timezoneLabel} = useTimezone()

  useEffect(() => {
    if (data && data.subClientAccountId && data.subClientAccountId !== '') {
      if (data._id !== data.ownerId) {
        setIsShowCredit(false)
      }
    }

    MenuComponent.reinitialization()
    
  }, [data])

  // const Admin = useSelector((state: any) => state?.AdminAuth?.adminData?.data?.user)
  const [backToSubAccount] = useLazyLoginBackToSubClientQuery()
  const [backToAffiliateParent] = useLoginAsParentAffiliateUserMutation()

  const logoutFunc = () => {
    dispatch(reset())
    user?.user !== undefined ? navigate('/auth/login') : navigate('/auth/admin')
  }

  const handleAdminLogin = () => {
    localStorage.setItem('isAdminAsUserRefresh', 'true')
    dispatch(resetRedux())
    dispatch(adminLoginBackToAdmin(data))
  }

  const handleSubAccountLogin = () => {
    if (isSubAccount === 'true') {
      dispatch(startLoadding())
      backToSubAccount(null)
        .then((res) => {
          if (res.data) {
            dispatch(resetRedux())
            const resData = res.data
            // reconfigure local storage
            localStorage.setItem('permission', JSON.stringify(resData.data.userPermissions))
            localStorage.setItem('currentUser', JSON.stringify(resData))
            localStorage.setItem('role', resData.data.user.role)
            localStorage.setItem('token', resData.data.token)
            if(!resData.data || !(resData.data.user.subClientAccountId && resData.data.user.subClientAccountId !== '')){
              localStorage.removeItem('isSubAccount')
            }

            dispatch(UpdateLoggedUserInfo(resData.data))
            navigate('/auth')
          } else if ('error' in res) {
            console.error('error login as user:', res.error)
            toast.error(res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
        .finally(() => {
          dispatch(stopLoading())
        })
    }
  }

  const handleAffiliateParentLogin = () => {
    if (isAffiliateParent === 'true') {
      dispatch(startLoadding())
      backToAffiliateParent(null)
        .then((res: any) => {
          if (res?.data) {
            dispatch(resetRedux())
            const resData = res.data
            // reconfigure local storage
            localStorage.setItem('permission', JSON.stringify(resData.data.userPermissions))
            localStorage.setItem('currentUser', JSON.stringify(resData))
            localStorage.setItem('role', resData.data.user.role)
            localStorage.setItem('token', resData.data.token)
            localStorage.removeItem('isAffiliateParent')

            dispatch(UpdateLoggedUserInfo(resData.data))
            navigate('/auth')
          } else if ('error' in res) {
            console.error('error login as user:', res.error)
            toast.error(res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
        .finally(() => {
          dispatch(stopLoading())
        })
    }
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-300px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            {data?.avatar == '' || data?.avatar == undefined || data?.avatar == 'undefined' ? (
              <span className='circle1'>{`${
                data?.firstName !== undefined && data?.firstName !== ''
                  ? data?.firstName?.split('')?.[0]?.toUpperCase() ?? 'C'
                  : createFirstLetter(data?.name)?.firstName ?? 'C'
              }${
                data?.lastName !== undefined && data?.lastName !== ''
                  ? data?.lastName?.split('')?.[0]?.toUpperCase() ?? 'C'
                  : createFirstLetter(data?.name).lastName ?? 'C'
              }`}</span>
            ) : (
              <img src={data?.avatar} alt='Cellcast' />
            )}
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-7'>{data?.name}</div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {data?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <Link to={'/accounts/overview'} className='menu-link px-5'>
          My Profile
        </Link>
      </div>

      {isAdmin === 'false' && (
        <>
          {AuthenticateUser('message-notification-configuration') && isShowCredit && (
            <div className='menu-item px-5'>
              <Link to={'/accounts/billing'} className='menu-link px-5'>
                Billing
              </Link>
            </div>
          )}
          {
            AuthenticateUser('send-quick-sms') && (
            <div className='menu-item px-5'>
              <Link to={'/accounts/api-keys'} className='menu-link px-5'>
                API
              </Link>
            </div>)
          }
          <div className='menu-item px-5'>
            <a href='mailto:support@cellcast.com' className='menu-link px-5'>
              Report a bug
            </a>
          </div>
          <div className='separator my-2'></div>
          {/* <Languages /> */}

          <div className='menu-item px-5'>
            <Link to={'/accounts/settings'} className='menu-link px-5'>
              Time zone &nbsp;
              <span>
                {timezoneLabel}
              </span>
            </Link>
          </div>
        </>
      )}

      {Admin?.role !== 'superAdmin' && (
        <div className='menu-item px-5'>
          <Link to={'/accounts/settings'} className='menu-link px-5'>
            Account Settings
          </Link>
        </div>
      )}
      {isAdminAsUser === 'false' && isAdminAsStaff === 'false' && (
        <div className='menu-item px-5'>
          <a
            onClick={() => {
              socketID?.disconnect()
              logoutFunc()
            }}
            className='menu-link px-5'
          >
            Sign Out
          </a>
        </div>
      )}
      {(isAdminAsUser === 'true' || isAdminAsStaff == 'true' )&& (
        <div className='menu-item px-5' onClick={handleAdminLogin}>
          <span className='menu-link px-5'>Redirect to Admin</span>
        </div>
      )}
      {isSubAccount === 'true' && (
        <div className='menu-item px-5' onClick={handleSubAccountLogin}>
          <span className='menu-link px-5'>Redirect to Owner</span>
        </div>
      )}

      {isAffiliateParent === 'true' && (
        <div className='menu-item px-5' onClick={handleAffiliateParentLogin}>
          <span className='menu-link px-5'>Redirect to parent</span>
        </div>
      )}
    </div>
  )
}

export default HeaderUserMenu
